import { logoutApp } from "@/apis/auth.api";
import { TokenKey, UserInfoKey } from "@/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { useNavigate } from "react-router-dom";

export function useLogoutBehavior(showSuccessMessage = true) {
  const navigate = useNavigate();
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { mutate: logout, isPending } = useMutation({
    mutationFn: () => logoutApp(),
    onSuccess: () => {
      localStorage.removeItem(TokenKey);
      localStorage.removeItem(UserInfoKey);
      // 清除所有 React Query 缓存，确保重新登录时获取最新数据
      queryClient.clear();

      navigate("/login");

      showSuccessMessage && message.success("退出成功");
    },
  });

  return { logout, logoutPending: isPending };
}
